export const RISK_REGISTER_STATUS_ID = {
    DRAFT: 'c69c51700a8911ed8bf4fa163e89e3c8', // แบบร่าง
    WAITING_FOR_REVIEW: 'cdea99a00a8911ed8bf4fa163e89e3c8', //รอตรวจสอบ
    REVIEWED: 'c18dc06a0a8911ed8bf4fa163e89e3c8', //ตรวจสอบแล้ว
    REVISE: 'ca30b7450a8911ed8bf4fa163e89e3c8', //ส่งคืนแก้ไข
};
